@if(hasKeyAndValue){
  <span class="key-value-pair">
    @if(iconName){
      <mat-icon class="notranslate">{{iconName}}</mat-icon>
    }
    <div class="info-item-content">
      <span class="key">{{ key }}: </span>
      @if (!!link){
        <a class="value link" target="_blank" [href]="link">{{ unit }}{{ value }}</a>
      } @else {
        <span class="value">{{unit}}{{value}}</span>
      }
    </div>
  </span>
}
